module.exports = __webpack_public_path__ + "static/img/2.d7b0a02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/eng/2.png
// module id = F9n2
// module chunks = 0